import { defineMessages } from 'react-intl';

export default defineMessages({
  columnHeaderLastCommitHash: {
    id: 'frontbucket.repository.source.directory.columnHeaderLastCommitHash',
    description:
      'Column header for the hash of the most recent commit that changed a file or directory',
    defaultMessage: 'Last commit',
  },
  columnHeaderLastCommitMessage: {
    id: 'frontbucket.repository.source.directory.columnHeaderLastCommitMessage',
    description:
      'Column header for the message from the most recent commit that changed a file or directory',
    defaultMessage: 'Message',
  },
  columnHeaderName: {
    id: 'frontbucket.repository.source.directory.columnHeaderName',
    description: 'Column header for file or directory name',
    defaultMessage: 'Name',
  },
  columnHeaderSize: {
    id: 'frontbucket.repository.source.directory.columnHeaderSize',
    description: 'Column header for file size',
    defaultMessage: 'Size',
  },
  directoryIconLabel: {
    id: 'frontbucket.repository.source.directory.directoryIconLabel',
    description: 'Icon label for a directory',
    defaultMessage: 'Directory,',
  },
  fileIconLabel: {
    id: 'frontbucket.repository.source.directory.fileIconLabel',
    description: 'Icon label for a file',
    defaultMessage: 'File,',
  },
  tooManyItemsToDisplay: {
    id: 'frontbucket.repository.source.directory.tooManyItemsToDisplay',
    description: 'Message to display when a directory listing is truncated.',
    defaultMessage: `Showing the first {count, number} items. If you're looking for a specific file, try the file filter.`,
  },
  parentDirectoryIconLabel: {
    id: 'frontbucket.repository.source.directory.parentDirectoryIconLabel',
    description: `Icon label for a link to the contents of a directory's parent`,
    defaultMessage: 'Parent directory,',
  },
  submoduleIconLabel: {
    id: 'frontbucket.repository.source.directory.submoduleIconLabel',
    description: 'Icon label for a Git submodule',
    defaultMessage: 'Submodule,',
  },
  subrepositoryIconLabel: {
    id: 'frontbucket.repository.source.directory.subrepositoryIconLabel',
    description: 'Icon label for a Hg subrepository',
    defaultMessage: 'Subrepository,',
  },
  announceStructure: {
    id: 'frontbucket.repository.source.directory.announceStructure',
    description:
      'Text that announce how many files and directories are displayed by path',
    defaultMessage:
      '{directoriesCount, plural, =0 {} one {one directory was displayed,} other {{directoriesCount} directories were displayed,}} {filesCount, plural, =0 {no files} one {one file was displayed} other {{filesCount} files were displayed}}, by path {path}',
  },
});
